module.exports = __webpack_public_path__ + "static/media/redirect.7fb5ad3c.gif";